import { render, staticRenderFns } from "./CatalogueListItem.vue?vue&type=template&id=51ef781e&scoped=true&"
import script from "./CatalogueListItem.vue?vue&type=script&lang=js&"
export * from "./CatalogueListItem.vue?vue&type=script&lang=js&"
import style0 from "./CatalogueListItem.vue?vue&type=style&index=0&id=51ef781e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ef781e",
  null
  
)

export default component.exports